<template>
    <div style="padding:3px;">
        <div v-for="(stts, index) in status" :key="index" style="float:left;">
            <b-icon-circle-fill v-if="stts.value" variant="success" class="statusled"></b-icon-circle-fill>
            <b-icon-circle v-else class="statusled"></b-icon-circle>
            <span class="statusled-text">{{stts.label}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "StatusPanel",
        props: ['status']
    }
</script>

<style scoped>
    .statusled {
        float:left;
        font-size:1.0em;
        margin-left:10px;
    }
    .statusled-text {
        font-size:0.8em;
        margin-left:3px;
        float:left;
    }
</style>
